export function TargetService({title, text}){
  return(
    <article className="target-service">
      <h4 className="subtitle">{title}</h4>
      <p className="text">{text}</p>
    </article>
  );
}
